<template>
  <div class="home">
    <!-- Header -->
    <div class="home-header">
      <top-header />

      <div class="home-header-caption">
        <!-- <img src="@/assets/images/offer_image.png" /> -->
        <h1>Our Nerds Can Help You</h1>
        <h2>With Your Online Class</h2>
        <p>Our Nerds are in the top 2% of their respective subjects and our clients save up to 60 hours per class when they utilize our services. Get a quote in 60 seconds or less now!</p>
      </div>

      <div class="home-header-mid">
        <div class="home-header-left">
          <!--<div class="home-header-lead">
            <p class="m800">Our</p>
            <h1 class="m900">Nerds</h1>
            <p class="m800">Can Help You Pass<br />Your Online Class.</p>
          </div>-->
          <div class="home-header-message">
            <h4>Get tutoring, right now.</h4>
            <text-me />
          </div>
          <div class="home-header-disclaimer">We will never spam you. We need your phone number to provide our services. <br>By clicking on the Text Me button, you agree to our <router-link to="/terms-of-service">Terms of Use</router-link>, <router-link to="/privacy">Privacy</router-link> and <router-link to="/cookie-policy">Cookie Policies</router-link>. </div>
        </div>
        <div class="home-header-right">
          <img :src="image" style="width: 100%;" />
          <div class="home-header-benefits">
            <p>
              <icon name="check-green" /> Instant reply
            </p>
            <p>
              <icon name="check-green" /> 100% Confidential
            </p>
            <p>
              <icon name="check-green" /> No Spam
            </p>
          </div>
          <div class="home-header-disclaimer">We will never spam you. We need your phone number to provide our services. <br>By clicking on the Text Me button, you agree to our <router-link to="/terms-of-service">Terms of Use</router-link>, <router-link to="/privacy">Privacy</router-link> and <router-link to="/cookie-policy">Cookie Policies</router-link>. </div>
        </div>
      </div>

    </div>

    <!-- Help -->
    <div class="home-help">
      <div class="container">
        <h3 class="m900 centered">How can Nerdhire help?</h3>
        <help-tabs />
      </div>
    </div>
    <!-- Getting started -->
    <div class="home-started">
      <div class="container">
        <h3 class="kanit400 centered">Getting started is simple</h3>
        <div class="home-started-grid">
          <div class="home-started-left-bubble proxima400">
            <img src="@/assets/images/left-bubble-icon.png" />
            We hire only the <br>most qualified nerds <br>in every field. </div>
          <animated-phone class="home-started-phone" />
          <!-- <img class="home-started-phone" src="@/assets/images/phone.jpg" /> -->
          <div class="home-started-right-bubble proxima400">
            <img src="@/assets/images/right-bubble-icon.png" />
            Affordable prices <br>and lightning fast <br>turnarounds. </div>
        </div>
      </div>
    </div>
    <!-- Steps -->
    <div class="home-steps">
      <!-- <div class="home-steps-rating">
        <icon name="five-stars" />
        <h3 class="m900">54,950</h3>
        <p>users rated our service 4.8 out of 5 stars!</p>
      </div> -->
      <div id="reviewsio-carousel-widget" class="home-steps-rating"></div>
      <h4 class="proxima400 home-steps-h4">Quick. Effective. <br>Always available. </h4>
      <div class="home-steps-list">
        <div class="home-steps-list-step">
          <img src="@/assets/images/steps-1.png" />
          <div class="home-steps-list-text">
            <p class="kanit700">STEP 1</p>
            <span>Send tutoring request details</span>
          </div>
        </div>
        <hr>
        <div class="home-steps-list-step">
          <img src="@/assets/images/steps-2.png" />
          <div class="home-steps-list-text">
            <p class="kanit700">STEP 2</p>
            <span>Get an affordable price quote</span>
          </div>
        </div>
        <hr>
        <div class="home-steps-list-step">
          <img src="@/assets/images/steps-3.png" />
          <div class="home-steps-list-text">
            <p class="kanit700">STEP 3</p>
            <span>Pay and get the help you need</span>
          </div>
        </div>
      </div>
    </div>
    <!-- Reviews -->
    <div class="home-reviews">
      <div class="home-reviews-slider">
        <div class="container">
          <h3 class="kanit400 centered">Our Customers Love <br>How Nerdy We Are</h3>
          <review-list />
        </div>
      </div>
      <div class="container">
        <h3 class="kanit400 centered home-reviews-a-header">Save Time & Stress <br>with Nerdhire</h3>
        <div class="home-reviews-text-reviews">
          <div class="home-reviews-text-reviews-column">
            <h4 class="proxima600">Spend less time…</h4>
            <ul>
              <li>
                <icon name="times-red" />Filling out lengthy forms
              </li>
              <li>
                <icon name="times-red" />Searching endlessly for freelancers
              </li>
              <li>
                <icon name="times-red" />No need for price negotiations
              </li>
            </ul>
          </div>
          <div class="home-reviews-text-reviews-column">
            <h4 class="proxima600">…get great results</h4>
            <ul>
              <li>
                <icon name="check-blue" />Instant reply to all of your requests
              </li>
              <li>
                <icon name="check-blue" />Drop a photo, video or text with your task
              </li>
              <li>
                <icon name="check-blue" />Live, free updates via SMS/Messenger
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- Press -->
    <div class="home-press">
      <h3 class="kanit400 centered">We’re in the press</h3>
      <div class="logos">
        <img src="@/assets/images/press-logos-mobile.png">
        <img src="@/assets/images/press-logos.png">
      </div>
    </div>
    <!-- Selection -->
    <div class="home-selection">
      <div class="container">
        <h3 class="kanit400 centered">We are VERY selective <br> with our nerds </h3>
        <div class="home-selection-wrapper">
          <div class="home-selection-rules">
            <h5>An acceptance rate of less than 5%</h5>
            <p>Our nerds are put through a series of rigorous tests to weed out the weak. They have each pledged their allegiance to our strict <router-link to="honor-code">Honor Code</router-link> to become part of the team. </p>
          </div>
          <div class="home-selection-chart">
            <icon name="pie-chart" />
            <ul>
              <li>
                <icon name="blue-oval" />Accepted as Nerds
              </li>
              <li>
                <icon name="yellow-oval" />Applicants
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- Uni-->
    <div class="home-uni">
      <div class="container">
        <h3 class="kanit400">From the top universities in the world</h3>
        <p>Nerds are freelance students and alumni from top US, UK and other world's best universities who can help you with various tasks. All of them have successfully passed our examination process, proven their competence and agreed to follow our <router-link to="honor-code">Honor Code</router-link>
        </p>
        <div class="home-uni-logos">
          <img src="@/assets/images/uni-logos-mobile.png" />
        </div>
        <div class="home-uni-logos-desktop">
          <img src="@/assets/images/stanford-logo.png" />
          <img src="@/assets/images/yale-logo.png" />
          <img src="@/assets/images/princeton-logo.png" />
          <img src="@/assets/images/harvard-logo.png" />
          <img src="@/assets/images/berkeley-logo.png" />
          <img src="@/assets/images/cornell-logo.png" />
          <img src="@/assets/images/mit-logo.png" />
        </div>
        <router-link to="/for-nerds" class="home-uni-become proxima600">Hire A Nerd</router-link>
      </div>
    </div>
    <!-- Skills -->
    <div class="home-skills">
      <div class="container">
        <h3 class="kanit400 centered">Our nerds specialize in <br> literally, everything… </h3>
      </div>
      <subject-list />
    </div>
    <!-- Popular tasks -->
    <div class="home-popular">
      <h3 class="kanit400 centered">Some of our most popular <br> tasks starting at just $30 </h3>
      <div class="container">
        <div class="home-popular-tasks">
          <div class="home-popular-task">
            <router-link to="/pay?task=30" class="btn">Buy for $30</router-link>
            <p>5 credible sources for a paper</p>
            <icon name="book" />
          </div>
          <div class="home-popular-task">
            <router-link to="/pay?task=40" class="btn">Buy for $40</router-link>
            <p>Proofreading and formatting a document</p>
            <icon name="doc" />
          </div>
          <div class="home-popular-task">
            <router-link to="/pay?task=50" class="btn">Buy for $50</router-link>
          <p>Review a finance or accounting project</p>
          <icon name="finance" />
        </div>
      </div>
    </div>
  </div>
  <!-- FAQ -->
  <div class="home-faq">
    <div class="container">
      <h3 class="kanit400 centered">Don’t see what you <br> need? Just ask. </h3>
      <div class="home-faq-textme">
        <h4>Get tutoring, right now.</h4>
        <text-me />
        <!-- <TextMeNew border /> -->
      </div>
      <div class="home-faq-grid">
        <div class="home-faq-column">
          <h4 class="proxima600">What tasks can a Nerd do?</h4>
          <p>Our Nerds can help with any task that pertains to educational assistance. Nerds can not engage in any tasks that are illegal or violate university and corporate policies. They can do almost anything so please dont hesitate to ask! Please see a list of our prohibited tasks.</p>
        </div>
        <div class="home-faq-column">
          <h4 class="proxima600">How do you find a qualified Nerd to assist with my task?</h4>
          <p>We have a proprietary algorithm that selects the best nerd qualified for your task. All nerds are put through a rigorous subject specific exam in order to gauge their level of expertise.</p>
        </div>
        <div class="home-faq-column">
          <h4 class="proxima600">How much should I pay for your service?</h4>
          <p>Getting a quote from Nerdhire is free! We only charge a small fee (10%) ub addition to the cheapest possible rate for products or services you request. Once we have the details of your task we will give you a price and it will not change once you are quoted. So you will always know exactly what you are paying and have piece of mind that there are no bait and switch tactics.</p>
        </div>
        <div class="home-faq-column">
          <h4 class="proxima600">How can I be sure my money is secure with you?</h4>
          <p>Once the order is made, we send you a payment link to the invoice. You can submit the payment with any Credit/Debit card. When following the link you are automatically taken to 128-bit encrypted HTTPS payment page. You can type your credit card information and initiate a transaction directly from your phone. Nerdhire has no access to your personal information, as well as to your CC data.</p>
        </div>
      </div>
    </div>
  </div>
  <!-- Cite -->
  <div class="home-cite">
    <h3 class="kanit400">
      <sup>“</sup>One of the best <br>tech startups in <br>the edu space <sub>”</sub>
    </h3>
    <p>Seth Rosenberg, Facebook <br>Messenger PM at F8 conference</p>
  </div>
  <!-- People -->
  <div class="home-people">
    <div class="container">
      <h3 class="kanit400 centered">We help people <br> like you every day </h3>
      <people-tabs />
    </div>
  </div>
  <!-- Tasks-->
  <div class="home-tasks">
    <div class="container">
      <h3 class="kanit400 centered">We’ve aced over 250+ <br>tasks in the last 24 hrs! </h3>
      <tasks-list />
    </div>
  </div>
  <!-- Partners -->
  <div class="home-partners">
    <div class="container">
      <h3 class="kanit400 centered">Our Partners</h3>
      <img src="@/assets/images/partners-mobile.png" class="home-partners-img-mobile">
      <img src="@/assets/images/partners.png" class="home-partners-img-desktop">
    </div>
  </div>
  <!-- Pricing -->
  <div class="home-pricing">
    <div class="container">
      <div class="home-pricing-grid">
        <div class="home-pricing-grid-image">
          <img src="@/assets/images/price-calculater.png">
        </div>
        <div class="home-pricing-text">
          <h3 class="kanit400">Our Pricing</h3>
          <p>How we determine our prices</p>
          <p>You only pay for the time a Nerd spends working on your specific task and the platform fee (10%) is included. We need a detailed description of the task to accurately quote you a price. We guarantee your satisfaction or we will give you a complete refund!</p>
          <p><b>We’re only satisfied when you’re satisfied and customer service is our top priority!</b></p>
          <router-link to="/pay?task=30" class="btn">Give Us A Try!</router-link>
          <p class="guarantee"><strong><icon name="check-green" /> 100% Money-Back Guarantee</strong></p>
        </div>
      </div>
    </div>
  </div>
  <!-- Retort -->
  <div class="home-retort">
    <div class="container">
      <h3 class="kanit400 centered"> Still not sure if you <br> need a nerd? </h3>
      <p>Message us to learn more about what Nerds can do! <br />Submit your mobile number, and we will text you back within seconds!</p>
      <div class="home-retort-textme">
        <h4>Get tutoring, right now.</h4>
        <text-me />
        <!-- <TextMeNew isPlacedAtBottom /> -->
      </div>
      <div class="home-retort-disclaimer">
        By clicking on the Message Me button, you agree to our <router-link to="/terms-of-service">Terms of Use</router-link>, <router-link to="/privacy">Privacy</router-link> and <router-link to="/cookie-policy">Cookie Policies</router-link>.
      </div>
    </div>
  </div>
  <!-- App Footer -->
  <sticky-navigation-bar />
  <app-footer />
</div>
</template>

<script>
import TopHeader from '@/components/TopHeader'
import TextMe from '@/components/TextMe'
// import TextMeNew from '@/components/TextMeNew'
import Icon from '@/components/Icon'
import AnimatedPhone from '@/components/AnimatedPhone'
import HelpTabs from '@/components/HelpTabs'
import ReviewList from '@/components/ReviewList'
import SubjectList from '@/components/SubjectList'
import PeopleTabs from '@/components/PeopleTabs'
import TasksList from '@/components/TasksList'
import AppFooter from '@/components/AppFooter'
import StickyNavigationBar from '../components/StickyNavigationBar.vue'
import newBannerImg from '../assets/images/new-banner.gif'

export default {
  name: 'Home',
  components: {
    TopHeader,
    TextMe,
    // TextMeNew,
    Icon,
    HelpTabs,
    AnimatedPhone,
    ReviewList,
    SubjectList,
    PeopleTabs,
    TasksList,
    AppFooter,
    StickyNavigationBar
  },
  mounted () {
    this.$gsap.from('.home-header-lead', {
      y: -30,
      scrollTrigger: {
        trigger: '.home-header-lead',
        start: 'top top',
        scrub: 2
      }
    })

    this.$gsap.from('.home-header-caption', {
      y: -30,
      scrollTrigger: {
        trigger: '.home-header-caption',
        start: 'top top',
        scrub: 2
      }
    })

    this.$gsap.from('.home-steps-rating', {
      y: 100,
      opacity: 0,
      scrollTrigger: {
        trigger: '.home-steps-rating',
        start: '+=50 bottom',
        end: '+=150',
        scrub: 1
      }
    })

    this.$gsap.from('.home-steps-h4', {
      y: 100,
      opacity: 0,
      scrollTrigger: {
        trigger: '.home-steps-h4',
        start: 'top bottom',
        end: '+=150',
        scrub: 1
      }
    })

    this.$gsap.from('.home-steps-list', {
      y: 100,
      opacity: 0,
      scrollTrigger: {
        trigger: '.home-steps-list',
        start: '+=50 bottom',
        end: '+=150',
        scrub: 1
      }
    })

    this.$gsap.from('.home-started-left-bubble', {
      y: 100,
      opacity: 0,
      scrollTrigger: {
        trigger: '.home-started-left-bubble',
        start: '+=50 bottom',
        end: '+=150',
        scrub: 1
      }
    })

    this.$gsap.from('.home-started-right-bubble', {
      y: 100,
      opacity: 0,
      scrollTrigger: {
        trigger: '.home-started-right-bubble',
        start: '+=50 bottom',
        end: '+=150',
        scrub: 2.5
      }
    })

    this.$gsap.from('.home-reviews-a-header', {
      y: 100,
      opacity: 0,
      scrollTrigger: {
        trigger: '.home-reviews-a-header',
        start: '+=50 bottom',
        end: '+=150',
        scrub: 1
      }
    })

    this.$gsap.from('.home-reviews-text-reviews', {
      y: 100,
      opacity: 0,
      scrollTrigger: {
        trigger: '.home-reviews-text-reviews',
        start: '+=50 bottom',
        end: '+=150',
        scrub: 1
      }
    })

    this.$gsap.from('.home-press', {
      y: 100,
      scrollTrigger: {
        trigger: '.home-press',
        start: '+=50 bottom',
        end: '+=150',
        scrub: 1
      }
    })

    this.$gsap.from('.home-uni', {
      y: 100,
      scrollTrigger: {
        trigger: '.home-uni',
        start: '+=50 bottom',
        end: '+=150',
        scrub: 1
      }
    })

    this.$gsap.from('.home-popular-task', {
      y: 100,
      opacity: 0,
      stagger: 0.4,
      scrollTrigger: {
        trigger: '.home-popular-task',
        start: 'top bottom',
        end: '+=50',
        scrub: 2
      }
    })

    this.$gsap.from('.home-cite', {
      y: 100,
      scrollTrigger: {
        trigger: '.home-cite',
        start: '+=50 bottom',
        end: '+=150',
        scrub: 1
      }
    })

    this.$gsap.from('.home-partners', {
      y: 100,
      scrollTrigger: {
        trigger: '.home-partners',
        start: '+=50 bottom',
        end: '+=150',
        scrub: 1
      }
    })

    this.$gsap.from('.home-pricing-thumb', {
      scale: 1.2,
      scrollTrigger: {
        trigger: '.home-pricing-thumb',
        start: '+=50 bottom',
        end: '+=150',
        scrub: 1
      }
    })

    this.$gsap.from('.home-retort', {
      y: 100,
      opacity: 0,
      scrollTrigger: {
        trigger: '.home-retort',
        start: '+=50 bottom',
        end: '+=150',
        scrub: 1
      }
    })
  },
  data () {
    return {
      image: newBannerImg
    }
  }
}
</script>

<style lang="scss">
  @import '~@/styles/media';

  .home {
    position: relative;
    /* HEADER */
    &-header {
      background-color: var(--primary-yellow);
      background-color: #fdc719;
      padding-bottom: 50px;

      &-caption {
        max-width: 650px;
        margin: 0 auto;
        padding: 40px 20px 0 20px;

        img {
          display: none;
        }

        h1 {
          font-family: 'Kanit';
          font-weight: normal;
          font-size: 50px;
          margin: 0;
          line-height: 50px;
        }
        h2 {
          font-family: 'Kanit Extra-Bold';
          font-size: 60px;
          margin: 0 0 15px 0;
        }
        p {
          font-size: 18px;
          font-family: 'ProximaNova-Bold';
          line-height: 28px;
          margin: 0;
        }

        @media #{$desktop} {
          max-width: 1000px;
          padding: 140px 20px 0 20px;

          img {
            display: block;
            float: right;
            max-width: 220px;
            margin-left: 20px;
          }
        }
        @media #{$lxs} {
          h1 {
            font-size: 8vw;
            line-height: 50px;
          }
          h2 {
            font-size: 8vw;
          }
          p {
            margin: 0;
          }
        }
        @media #{$sxs} {
          padding-top: 40px;
          h1 {
            font-size: 8vw;
            line-height: 28px;
            margin-bottom: 8px;
          }
          h2 {
            font-size: 8vw;
            margin-bottom: 7px;
            line-height: 30px;
          }
          p {
            font-size: 3.6vw;
            line-height: 20px;
          }
        }
      }

      &-mid {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        width: calc(100% - 40px);
        max-width: 650px;
        padding: 0 20px;
        margin: 0 auto;

        @media #{$desktop} {
          max-width: inherit;
        }

        @media #{$lxs} {
          padding: 0;
        }
      }

      &-lead {
        padding: 20px 20px 0 20px;
        line-height: 0.7;

        h1, h2, p {
          margin: 0;
        }

        p {
          font-size: 29px;
          line-height: 1.1;
          font-weight: bold;
        }

        h1 {
          font-size: 23vw;
          line-height: .8;
          text-transform: uppercase;
          font-style: italic;
          font-family: 'Kanit', sans-serif;
        }

        h2 {
          font-size: 35px;
          text-align: right;
        }
      }

      &-left {

        @media #{$mobile} {
          width: 100%;
        }
      }

      &-right {
        width: 560px;
        max-width: 100%;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding-left: 20px;

        h4 {
          font-size: 18px;
          font-weight: bold;
          margin: 0;
          line-height: 30px;
          text-align: center;
        }

        .home-header-disclaimer {
          display: none;

          @media #{$mobile} {
            display: block;
            padding-left: 0;
            padding-right: 0;
          }
        }

        @media #{$mobile} {
          padding-left: 0;
        }
      }

      &-message {
        padding: 20px;
        background: #ffde75;
        border-radius: 10px;

        h4 {
          font-size: 20px;
          font-weight: normal;
          margin: 0 0 10px;
          font-family: 'Kanit Extra-Bold';
        }

        @media #{$sxs} {
          padding: 13px 20px 20px 20px;
        }
      }

      &-benefits {
        padding: 20px 0 10px 0;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        grid-column-gap: 10px;
        font-size: 15px;
        white-space: nowrap;
        justify-items: center;
        margin: 0;

        p {
          display: grid;
          grid-template-columns: auto 1fr;
          grid-column-gap: 10px;
          align-items: center;
          margin: 0;
          font-size: 16px;
        }
        @media #{$lxs} {
          p {
            font-size: 13px;
            grid-column-gap: 2px;
          }
        }
        @media #{$sxs} {
          padding: 0;
          p {
            font-size: 11px;
            grid-column-gap: 2px;
          }
        }
      }

      &-disclaimer {
        text-align: center;
        padding: 10px 20px 5px 20px;
        font-size: 9px;
        line-height: 1.5;

        a {
          color: var(--primary-black);
        }

        @media #{$mobile} {
          display: none;
        }
      }

      @media #{$desktop} {
        // background-image: url('~@/assets/images/nerd-figure.jpg');
        // background-repeat: no-repeat;
        // background-size: cover;
        // background-position: center 25%;
        // height: auto;

        &-lead {
          width: 390px;
          margin: 0;

          h1 {
            font-size: 100px;
            line-height: 0.7;
            margin: 0;
            padding-bottom: 8px;
          }

          h2 {
            text-align: right;
            font-size: 32px;
            margin: 0;
          }

          h3 {
            font-size: 32px;
            margin: 0;
          }

          p {
            font-size: 32px;
          }
        }

        &-right {
          display: flex;
        }

        &-message, &-disclaimer {
          width: 400px;
          margin: 0 0 0 0;
        }
      }

      @media #{$xs} {
        &-benefits {
          padding: 5px;
          grid-column-gap: 7px;

          svg {
            width: 14px;
          }
        }
      }
    }
    /* STEPS */
    &-steps {
      text-align: center;
      padding: 50px 20px;
      color: var(--primary-white);
      background-color: var(--primary-black);

      h3 {
        font-size: 72px;
        margin: 0;
        line-height: 1;
      }

      p {
        font-size: 22px;
        margin: 0;
      }

      h4 {
        font-size: 28px;
        line-height: 1.4;
      }

      &-list {
        text-align: left;
        display: grid;
        justify-content: center;
        grid-row-gap: 40px;

        hr {
          display: none;
        }

        p {
          font-weight: bold;
          padding: 0;
          margin: 0 0 10px 0;
          text-align: center;
        }

        &-step {
          margin: 0;

          img {
            display: block;
            margin: 0 auto 30px auto;
            }
        }

        &-text {
          font-size: 18px;
          text-align: center;
          font-family: 'ProximaNova-Bold';
        }
      }

      @media #{$desktop} {
        padding: 70px 0 110px;

        &-rating {
          margin-bottom: 70px;

          h3 {
            margin: 5px 0 0;
            font-size: 72px;
            line-height: 1.1;
          }

          p {
            margin: 0;
            font-size: 14px;
          }
        }

        h4 {
          margin: 0 0 50px;
          font-size: 38px;

          br {
            display: none;
          }
        }

        &-list {
          text-align: center;
          display: grid;
          grid-template-columns: auto 1fr auto 1fr auto;
          width: 70%;
          max-width: 900px;
          margin: 0 auto;
          padding-bottom: 74px;

          hr {
            display: block;
            height: 1px;
            border: 0;
            border-top: 2px dashed var(--dashed-blue);
            width: calc( 100% + 190px );
            margin-top: 110px;
            position: relative;
            left: -74px;
          }

          p {
            font-weight: bold;
            padding: 0;
          }

          &-step {
            position: relative;
            height: 193px;
            grid-column-gap: 0;
            width: 250px;
          }

          &-text {
            width: 250px;
            position: absolute;
            left: 0;
            bottom: -74px;
          }
        }
      }

      @media #{$mobile} {
        padding-top: 300px;

        #reviewsio-carousel-widget {
          margin: 0 -20px;
        }
        .CarouselWidget__list {
          padding: 0 !important;
        }
        .item__inner { padding: 0 !important;}
      }
    }
    /* HELP */
    &-help {
      padding: 30px 0;

      h3 {
        margin-bottom: 10px;
        font-family: 'Kanit';
        font-weight: 400;
      }

      @media #{$desktop} {
        padding: 50px 0;
        br { display: none; }
      }
    }
    /* GETTING STARTED */
    &-started {
      border-bottom: 16px solid var(--fb-blue);

      h3 {
        margin-bottom: 20px;
      }

      &-left-bubble, &-right-bubble {
        text-align: center;
        font-size: 22px;
        padding: 30px;
        height: 288px;
        width: 288px;
        margin: 0 auto;
        display: grid;
        line-height: 1.3;
        align-items: center;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        position: relative;

        img {
          display: block;
          margin: 0 auto -30px auto;
          max-width: 50px;
        }
      }

      &-left-bubble {
        background-image: url('~@/assets/images/left-color-oval.png');
        margin-bottom: -70px;
      }

      &-phone {
        width: 100%;
        max-width: 400px;
        position: relative;
        display: block;
        z-index: 0;
        margin: 0 auto -16px auto;
        background-color: var(--primary-white);
        @media #{$mobile} {
          margin: 0 auto -68px auto;
        }
      }

      &-right-bubble {
        margin-top: 30px;
        background-image: url('~@/assets/images/right-color-oval.png');
        z-index: 1;
        color: #fff;
      }

      @media #{$desktop} {
        &-grid {
          display: grid;
          align-items: center;
          margin-top: 40px;
          grid-template-columns: repeat(3, auto);
          justify-content: space-evenly;
        }

        &-left-bubble {
          margin-bottom: 0;
          background-image: url('~@/assets/images/left-color-oval.png');
        }

        &-right-bubble {
          margin-top: 0;
          background-image: url('~@/assets/images/right-color-oval.png');
        }
      }
      @media #{$mobile} {
        border-bottom: none;

        &-right-bubble {
          margin-bottom: -250px;
          img {
            max-width: 70px;
          }
        }

        &-left-bubble {
          display: block;
          img {
            display: block;
            margin: 10px auto 0 auto;
            max-width: 70px;
          }
        }
      }
    }
    /* REVIEWS */
    &-reviews {
      margin-top: 0;
      position: relative;
      padding: 0 0 170px;
      background-color: var(--primary-yellow);

      &-slider {
        background-color: var(--primary-black);
        margin-bottom: 30px;

        h3 {
          color: var(--primary-yellow);
        }
      }

      &-text-reviews {
        padding: 0;
        margin-bottom: 60px;

        h4 {
          font-size: 22px;
        }

        svg {
          height: 27px;
          width: 27px;
        }

        ul {
          padding: 0;
          margin: 0;
          list-style: none;
        }

        li {
          margin-bottom: 15px;
          display: grid;
          grid-template-columns: auto 1fr;
          align-items: center;
          grid-column-gap: 15px;
        }
      }

      @media #{$desktop} {
        margin-top: 0;
        padding: 0 0 120px;

        br {
          display: none;
        }

        &-slider {
          margin-bottom: 60px;
        }

        &-text-reviews {
          text-align: left;
          font-size: 18px;
          display: grid;
          grid-template-columns: auto auto;
          justify-content: space-evenly;
          grid-column-gap: 40px;
          width: 70%;
          margin: 0 auto 50px;

          h5 {
            margin: 0;
            font-size: 18px;
          }

          ul {
            padding: 0;
            list-style: none;

            li {
              display: grid;
              grid-template-columns: auto 1fr;
              grid-column-gap: 20px;
              align-items: center;
              margin-bottom: 15px;
            }
          }
        }
      }
    }
    /* PRESS */
    &-press {
      background-color: white;
      border-radius: 12px;
      padding: 30px 0 20px;
      box-shadow: var(--basic-shadow);
      border: 1px solid rgba(var(--solid-grey-rgba), .41);
      position: relative;
      margin: -170px 20px 0;

      h3 {
        margin-bottom: 30px;
      }

      .logos {
        padding: 0 30px;

        img {
          width: 100%;

          &:last-child {
            display: none;
          }
        }
      }

      @media #{$desktop} {
        width: 70%;
        max-width: 980px;
        margin: -120px auto 0;
        padding: 40px 20px 50px;

        img {
          &:first-child {
            display: none;
          }

          &:last-child {
            display: block!important;
          }
        }
      }
    }
    /* SELECTION */
    &-selection {
      margin: 60px 0;

      &-wrapper {
        display: grid;
      }

      &-rules {
        font-size: 14px;
        text-align: left;
        display: block;
        order: 2;

        h5 {
          display: inline-block;
          background-color: var(--primary-green);
          color: var(--primary-white);
          font-family: 'ProximaNova-Bold';
          padding: 10px;
          position: relative;
          font-size: 18px;
          margin-bottom: 20px;
        }

        p {
          margin: 0;
          line-height: 26px;
          padding-left: 15px;
        }

        a {
          color: var(--primary-black);
        }

        @media #{$mobile} {
          max-width: 400px;
          margin: 0 auto;
          position: relative;
          z-index: 2;
          text-align: center;

          h5 {
            margin-bottom: 0;
          }

          p {
            font-size: 14px;
            line-height: 22px;
          }
        }
        @media #{$sxs} {
          p {
            font-size: 3.3vw;
          }
        }
      }

      &-chart {
        display: grid;
        grid-template-columns: auto auto;
        grid-column-gap: 20px;
        align-items: center;
        text-align: left;

        svg {
          width: 100%;
        }

        ul {
          list-style-type: none;
          margin: 0;
          padding: 0;
          line-height: 1.8;

          li {
            font-size: 15px;
            display: grid;
            grid-template-columns: 19px 1fr;
            grid-column-gap: 10px;
            align-items: center;
            white-space: nowrap;
          }
        }
        @media #{$mobile} {
          max-width: 400px;
          margin: 0 auto;

          .icon{

            &:after {
              content: "";
              position: absolute;
              top: 60px;
              right: 50px;
              border-right: 2px dashed var(--primary-green);
              display: block;
              width: 1px;
              height: 100%;
            }
          }

          ul li .icon:after {
            display: none;
          }
        }

        @media #{$sxs} {
          .icon{
            svg {
              height: auto;
            }
            &:after {
              right: 30px;
              top: 40px;
            }
          }
        }

        @media #{$s} {
          .icon{
            svg {
              height: auto;
            }
            &:after {
              right: 25px;
            }
          }
        }
      }

      @media #{$desktop} {
        br {
          display: none;
        }

        &-wrapper {
          grid-template-columns: 1fr 1fr;
          grid-column-gap: 90px;
          max-width: 950px;
          margin: 30px auto;
        }

        &-rules {
          font-size: 18px;
          order: 0;

          h5 {
            display: inline-block;
            background-color: var(--primary-green);
            color: var(--primary-white);
            font-family: 'ProximaNova-Bold';
            padding: 10px;
            position: relative;

            &:before {
              content: "";
              border-top: 2px dashed var(--primary-green);
              position: absolute;
              top: 19px;
              left: 100%;
              display: block;
              width: 400px;
              z-index: 1;
            }
          }
        }
      }
    }
    /* UNI */
    &-uni {
      margin: 50px 20px 50px;
      background-color: white;
      border-radius: 12px;
      padding: 10px 10px 40px;
      box-shadow: var(--basic-shadow);
      border: 1px solid rgba(var(--solid-grey-rgba), .41);
      text-align: center;

      a {
        color: var(--primary-black);
      }

      h3 {
        margin-top: 15px;
        margin-bottom: 20px;
      }

      p {
        font-size: 14px;
        line-height: 1.6;
      }

      &-logos {
        margin: 10px -20px;

        img {
          width: 90%;
        }
      }

      &-logos-desktop {
        display: none;
      }

      &-become {
        background-color: var(--primary-green);
        border-radius: 5px;
        width: 200px;
        height: 52px;
        display: inline-block;
        cursor: pointer;
        color: var(--primary-white)!important;
        text-decoration: none;
        line-height: 52px;
        transition: background-color .2s ease-out;
        box-shadow: 6px 6px 0px #d8d8d8;
        font-size: 17px;

        &:hover {
          background-color: var(--primary-green-hover);
        }

        @media #{$mobile} {
          display: none;
        }
      }

      @media #{$desktop} {
        width: 70%;
        max-width: 960px;
        margin: 0 auto;
        padding: 20px 20px 40px;

        &-logos {
          display: none;
        }

        &-logos-desktop {
          display: block;
          margin: 40px 0;

          img {
            display: inline-block;
            margin: 20px 40px;
            vertical-align: middle;
          }
        }

        p {
          width: 80%;
          margin: 0 auto;
          font-size: 16px;
        }
      }

      @media #{$mobile} {
        padding: 0;
      }
    }
    /* Skills */
    &-skills {
      @media #{$desktop} {
        padding: 70px 0 40px;

        br {
          display: none;
        }
      }
      @media #{$mobile} {
        padding: 0;
      }
    }
    /* Popular */
    &-popular {
      padding: 20px 0;

      &-tasks {
        margin-top: 30px;
        text-align: center;
      }

      &-task {
        padding: 30px 0;
        // background-color: var(--secondary-yellow);
        background-color: #FFC600;
        border-radius: 8px;
        margin-bottom: 20px;
        transition: box-shadow .2s ease-out;

        &:hover {
          box-shadow: var(--hover-shadow);
        }

        .btn {
          display: inline-block;
          width: 220px;
          height: 52px;
          line-height: 52px;
          border-radius: 5px;
          margin-bottom: 10px;
          color: var(--primary-white);
          background-color: var(--primary-green);
          cursor: pointer;
          transition: background-color .2s ease-out;
          font-size: 17px;
          text-decoration: none;
          font-family: 'ProximaNova-Bold';
          text-transform: uppercase;

          &:hover {
            background-color: var(--primary-green-hover);
          }
        }

        p {
          max-width: 250px;
          margin: 0 auto 15px auto;

          @media #{$mobile} {
            margin-bottom: 25px;
          }
        }
      }

      @media #{$desktop} {
        br {
          display: none;
        }

        &-tasks {
          width: 80%;
          max-width: 950px;
          margin: 30px auto 0;
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
          grid-column-gap: 40px;
        }
      }
    }
    /* FAQ */
    &-faq {
      padding: 20px 0;

      h3 {
        margin-bottom: 20px;
      }

      &-textme {
        max-width: 400px;
        margin: 0 auto;
        padding: 20px;
        background-color: #ffde75;
        border-radius: 5px;

        h4 {
          font-size: 30px;
          margin: 0 0 20px 0;
          font-size: 20px;
          font-weight: 400;
          font-family: Kanit Extra-Bold;

          @media #{$mobile} {
            font-size: 20px;
            text-align: left;
          }
        }

        .textme-form {
          // display: flex;
          // flex-wrap: wrap;

          .form-field {
            // width: 50%;
            // padding: 0 10px;
            position: relative;
            z-index: 1;
            height: 40px;
            margin-bottom: 20px;

            label {
              position: absolute;
              left: 0px;
              top: 14px;
              transition: all 0.3s ease;
              font-size: 16px;
              z-index: -2;

              &:nth-child(1) {
                display: none;
              }

              &:nth-child(3) {
                display: block;
              }
            }

            input {
              background-color: transparent;
              padding: 0;
              border-radius: 0;
              border: none;
              border-bottom: 2px solid #000100;
              height: 40px;
              font-family: ProximaNova-Bold;
              font-size: 17px;

              &:focus {
                box-shadow: none;
              }
            }
            @media #{$mobile} {
              width: 100%;
              padding: 0;
            }
          }

          .form-field input:focus + label, input:not(:placeholder-shown) ~ label {
            top: -7px;
            left: 0px;
            font-size: 12px;
          }

          button {
            height: 52px;
            line-height: 52px;
            font-family: 'ProximaNova-Bold';
            font-size: 17px;
            width: 420px;
            max-width: 100%;
            border-radius: 5px;
            margin: 20px auto 0 auto;
            display: block;
            box-shadow: 5px 5px 0 #d9bb65;
          }
        }

        &-benefits {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          padding: 15px 0 0 0;

          p {
            margin: 0 10px;
          }

          .icon {
            vertical-align: middle;
            margin-right: 6px;
          }
        }

        &-disclaimer {
          text-align: center;
          font-size: 12px;
          line-height: 22px;
          padding: 20px 0 0 0;

          br {
            display: block !important;
          }

          a {
            color: var(--primary-black);
          }
        }
        @media #{$mobile} {
          margin-bottom: 50px;

          &-benefits {
            padding: 40px 0 0 0;
            margin-bottom: -55px;
            font-size: 14px;
            margin-left: -20px;
            margin-right: -20px;
          }
          &-disclaimer {
            display: none;
          }
        }
        @media #{$mobile} {
          &-benefits {
            p {
              margin: 0 4px !important;
              font-size: 11px;
            }
            .icon {
              margin-right: 1px;
              svg {
                width: 15px;
                height: 15px;
              }
            }
          }
        }
      }

      &-grid {
        margin-top: 20px;
        display: grid;
        grid-row-gap: 23px;

        h4 {
          margin: 0;
          font-size: 18px;
          color: var(--fb-blue);
          margin-bottom: 10px;
          font-weight: 900;
        }

        p {
          margin: 0;
          font-size: 17px;
          line-height: 1.6;
        }
        @media #{$mobile} {
          h4 {
            color: var(--primary-black);
            font-size: 22px;
            line-height: 22px;
          }
        }
      }

      @media #{$desktop} {
        br {
          display: none;
        }

        &-grid {
          width: 1000px;
          max-width: 100%;
          margin: 100px auto 0;
          text-align: left;
          display: grid;
          grid-column-gap: 55px;
          grid-row-gap: 23px;
          grid-template-columns: 1fr 1fr;

          h4 {
            margin: 0;
            font-size: 22px;
            color: var(--primary-black);
            margin-bottom: 10px;
            line-height: 32px;
          }

          p {
            margin: 0;
            font-size: 17px;
            line-height: 1.7;
          }
        }
      }
    }
    /* Cite */
    &-cite {
      text-align: center;
      background-color: #FDC719;
      border-radius: 12px;
      padding: 30px 30px;
      margin: 20px auto;
      box-shadow: var(--basic-shadow);
      width: 70%;

      sup, sub {
        color: var(--primary-white);
        font-size: 68px;
        line-height: 0;
        height: 20px;
        position: relative;
        top: 20px;
      }

      p {
        margin: 0;
      }

      @media #{$desktop} {
        max-width: 940px;
        margin: 30px auto 50px auto;
        padding: 50px 40px;

        br {
          display: none;
        }
      }
      @media #{$sxs} {
        h3 {
          font-size: 7vw;
        }
        p {
          font-size: 4vw;
          line-height: 27px;
        }
      }
    }
    /* People */
    &-people {
      padding: 30px 0;
      @media #{$desktop} {
        br {
          display: none;
        }
      }
    }
    /* Tasks */
    &-tasks {
      @media #{$desktop} {
        br {
          display: none;
        }
      }
    }
    /* Partners */
    &-partners {
      text-align: center;
      background-color: white;
      border-radius: 12px;
      margin: 20px;
      padding: 30px;
      border: 1px solid rgba(var(--solid-grey-rgba), .41);
      box-shadow: var(--basic-shadow);

      h3 {
        margin: 0 0 40px;
      }

      &-img-mobile {
        width: 100%;
        display: block;
      }

      &-img-desktop {
        display: none;
      }

      @media #{$desktop} {
        margin: 70px auto;
        width: 70%;
        max-width: 950px;
        background-color: white;
        border-radius: 12px;
        padding: 50px;

        &-img-mobile {
          display: none;
        }

        &-img-desktop {
          width: 100%;
          display: block;
        }
      }
    }
    /* Pricing */
    &-pricing {
      padding: 30px 0;
      text-align: center;

      &-text {
        text-align: left;
      }

      b {
        color: var(--dashed-blue);
        font-size: 18px;
        font-family: 'ProximaNova-Bold';
      }

      h4 {
        font-size: 18px;
        margin: 0;
      }

      p {
        font-size: 16px;

        &:nth-child(2) {
          margin-top: 0;
        }
      }

      p, b {
        line-height: 1.5;
      }

      .btn {
        display: inline-block;
        width: 220px;
        height: 52px;
        line-height: 52px;
        border-radius: 5px;
        color: var(--primary-white);
        background-color: var(--primary-green);
        cursor: pointer;
        transition: background-color .2s ease-out;
        font-size: 17px;
        text-decoration: none;
        font-family: 'ProximaNova-Bold';
        text-align: center;

        &:hover {
          background-color: var(--primary-green-hover);
        }
      }

      .icon {
        vertical-align: middle;
        margin: 0 10px 0 0;
      }

      @media #{$desktop} {
        &-grid {
          width: 80%;
          max-width: 1000px;
          margin: 0 auto;
          text-align: left;
          display: grid;
          grid-template-columns: 1fr auto;
          grid-column-gap: 30px;

          .icon {
            order: 2;
          }

          p {
            font-size: 16px;
          }
        }

        &-text {
          padding-right: 70px;
        }
      }
      @media #{$mobile} {
        &-grid {
          display: flex;
          flex-wrap: wrap;

          &-image {
            width: 100%;
            order: 2;
            img {
              max-width: 100%;
            }
          }
        }
        &-text {
          width: 100%;
          order: 1;
        }
      }
      @media #{$lxs} {
        &-text {
          .btn {
            width: 480px;
            max-width: 100%;
          }
        }
      }
      @media #{$sxs} {
        &-text {
          p.guarantee {
            text-align: center;
          }
        }
      }
    }
    /* Retort */
    &-retort {
      margin-bottom: 60px;

      h3 {
        margin-bottom: 0;
      }

      h4 {
        text-align: center;
        font-size: 30px;
        margin: 0 0 20px 0;
      }

      p {
        text-align: center;
        line-height: 1.5;
        font-size: 16px;

        br {
          display: block;
        }
      }
      &-textme {
        max-width: 400px;
        margin: 0 auto;
        padding: 20px;
        background-color: #ffde75;
        border-radius: 5px;

        h4 {
          text-align: left;
          margin: 0 0 20px 0;
          font-size: 20px;
          font-weight: 400;
          font-family: Kanit Extra-Bold;
        }

        .textme-form {
          // display: flex;
          // flex-wrap: wrap;

          .form-field {
            // width: 50%;
            // padding: 0 10px;
            position: relative;
            z-index: 1;
            height: 40px;
            margin-bottom: 20px;

            label {
              position: absolute;
              left: 0px;
              top: 14px;
              transition: all 0.3s ease;
              font-size: 16px;
              z-index: -2;

              &:nth-child(1) {
                display: none;
              }

              &:nth-child(3) {
                display: block;
              }
            }

            input {
              background-color: transparent;
              padding: 0;
              border-radius: 0;
              border: none;
              border-bottom: 2px solid #000100;
              height: 40px;
              font-family: 'ProximaNova-Bold';

              &:focus {
                box-shadow: none;
              }
            }
          }

          .form-field input:focus + label, input:not(:placeholder-shown) ~ label {
            top: -7px;
            left: 0px;
            font-size: 12px;
          }

          button {
            height: 52px;
            line-height: 52px;
            font-family: 'ProximaNova-Bold';
            font-size: 17px;
            width: 420px;
            max-width: 100%;
            border-radius: 5px;
            margin: 20px auto 0 auto;
            display: block;
            box-shadow: 5px 5px 0 #d9bb65;
          }
        }

        &-benefits {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          padding: 15px 0 0 0;

          p {
            margin: 0 10px !important;
          }

          .icon {
            vertical-align: middle;
            margin-right: 6px;
          }
        }

        &-disclaimer {
          text-align: center;
          font-size: 12px;
          line-height: 22px;
          padding: 20px 0 0 0;

          br {
            display: block !important;
          }

          a {
            color: var(--primary-black);
          }
        }
        @media #{$mobile} {
          margin-bottom: 20px;
          h3 {
            line-height: 28px;
          }
          h4 {
            font-size: 20px;
            text-align: left;
          }
          .textme-form {

            .form-field {
              width: 100%;
              padding: 0;
            }
          }
          &-disclaimer {
            display: none;
          }
          &-benefits {
            padding: 45px 0 0 0;
            margin-bottom: -60px;
            p {
              margin: 0 8px !important;
              font-size: 14px;
            }
          }
        }
        @media #{$sxs} {
          &-benefits {
            margin-left: -20px;
            margin-right: -20px;
            p {
              margin: 0 4px !important;
              font-size: 11px;
            }
            .icon {
              margin-right: 1px;
              svg {
                width: 15px;
                height: 15px;
              }
            }
          }
        }
      }

      &-disclaimer {
        font-size: 9px;
        text-align: center;
        max-width: 80%;
        margin: 0 auto;
        line-height: 1.7;

        a {
          color: var(--primary-black);
        }
      }

      @media #{$desktop} {
        margin: 50px 0 70px;

        br {
          display: none;
        }

        p {
          max-width: 600px;
          margin: 0 auto 15px auto;
          font-size: 18px;
        }

        &-textme {
          margin: 0 auto 20px;
        }
      }
      @media #{$mobile} {
        p {
          br {
            display: none;
          }
        }
      }
      @media #{$sxs} {
        p {
          font-size: 4vw;
        }
      }
    }
  }
</style>
